export default function TrustSignals() {
  const stats = [
    { number: "1,000+", label: "Events Serviced" },
    { number: "500+", label: "Rental Items" },
    { number: "15+", label: "Years Experience" },
    { number: "98%", label: "Client Satisfaction" },
  ];

  const testimonials = [
    {
      quote:
        "St. Stephen's Rentals transformed our corporate gala into an unforgettable evening. The quality and service exceeded expectations.",
      author: "Mitchell Daniels",
      role: "Event Director",
    },
    {
      quote:
        "From our initial inquiry to final pickup, everything was seamless. Their inventory is stunning and the team is incredibly professional.",
      author: "Adeyemisi Adeyinka",
      role: "Wedding Planner",
    },
    {
      quote:
        "We've used St. Stephen's for multiple events. Their attention to detail and reliability make them our go-to rental partner.",
      author: "Jennifer Nwabueze",
      role: "Nonprofit Coordinator",
    },
  ];

  return (
    <section className="py-20 md:py-28 px-6 bg-gradient-to-b from-[#FAFAFA] to-white dark:from-[#1A1A1A] dark:to-[#121212]">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-20 grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center p-8 bg-white dark:bg-[#1E1E1E] rounded-2xl border border-[#E9E9E9] dark:border-[#333333] transition-all hover:border-[#62397f] hover:shadow-xl"
            >
              <div
                className="text-[#62397f] font-medium font-serif mb-2"
                style={{
                  fontSize: "clamp(30px, 4vw, 42px)",
                }}
              >
                {stat.number}
              </div>
              <div className="text-[#666666] dark:text-[#A0A0A0] font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
        <h2
          className="text-black dark:text-white font-medium font-serif mb-12 text-center"
          style={{
            fontSize: "clamp(32px, 5vw, 48px)",
          }}
        >
          Trusted by Event Professionals
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((t, index) => (
            <div
              key={index}
              className="bg-white dark:bg-[#1E1E1E] rounded-2xl p-8 border border-[#E9E9E9] dark:border-[#333333] transition-all hover:border-[#62397f] hover:shadow-xl transform hover:-translate-y-1"
            >
              <p className="text-[#333333] dark:text-[#E0E0E0] mb-6 italic">
                "{t.quote}"
              </p>
              <div className="border-t border-[#E9E9E9] dark:border-[#333333] pt-4">
                <p className="font-bold text-black dark:text-white">{t.author}</p>
                <p className="text-sm text-[#666666] dark:text-[#A0A0A0]">{t.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
